import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  fetchNotificationInbox,
  markNotificationsRead,
  dismissNotification,
} from "./notificationCenterApi";

function formatNotificationTime(value) {
  if (!value) return "";
  try {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "";
    const diffMs = Date.now() - d.getTime();
    const mins = Math.floor(diffMs / 60000);
    if (mins < 1) return "Just now";
    if (mins < 60) return `${mins}m ago`;
    const hours = Math.floor(mins / 60);
    if (hours < 24) return `${hours}h ago`;
    const days = Math.floor(hours / 24);
    if (days < 7) return `${days}d ago`;
    return d.toLocaleDateString();
  } catch (e) {
    return "";
  }
}

/**
 * Phase B Notification Center bell — unified inbox with read/dismiss.
 */
class NotificationBell extends Component {
  state = {
    open: false,
    loading: true,
    items: [],
    unreadCount: 0,
  };

  componentDidMount() {
    this.load();
    this._timer = setInterval(this.load, 60000);
  }

  componentWillUnmount() {
    if (this._timer) clearInterval(this._timer);
  }

  load = async () => {
    const data = await fetchNotificationInbox({ take: 12 });
    this.setState({
      loading: false,
      items: (data && data.items) || [],
      unreadCount: (data && data.unread_count) || 0,
    });
  };

  toggle = () => {
    this.setState((s) => ({ open: !s.open }));
  };

  markAll = async () => {
    await markNotificationsRead({ markAll: true });
    this.load();
  };

  markOne = async (id) => {
    await markNotificationsRead({ notificationId: id });
    this.load();
  };

  dismissOne = async (e, id) => {
    e.preventDefault();
    e.stopPropagation();
    await dismissNotification({ notificationId: id });
    this.load();
  };

  render() {
    const { open, loading, items, unreadCount } = this.state;
    return (
      <li className={`nav-item dropdown ${open ? "show" : ""}`}>
        <button
          type="button"
          className="nav-link notification dropdown-toggle btn btn-link"
          onClick={this.toggle}
          aria-label="Notifications"
          style={{ border: "none", background: "transparent" }}
        >
          <div className="notification-count">{loading ? "" : unreadCount}</div>
          <i className="fas fa-bell" />
        </button>
        {open ? (
          <div className="dropdown-menu notification-drop show" style={{ display: "block" }}>
            <div className="notification-onoff d-flex justify-content-between align-items-center px-2">
              <span>Notifications</span>
              {unreadCount > 0 ? (
                <button type="button" className="btn btn-link btn-sm" onClick={this.markAll}>
                  Mark all read
                </button>
              ) : null}
            </div>
            <div className="notification-drop-height">
              {items.length === 0 ? (
                <p className="px-3 py-2 text-muted mb-0">No notifications</p>
              ) : (
                items.map((n) => (
                  <div
                    key={n.id || n.uuid}
                    className="notify-item"
                    style={{
                      opacity: n.read_status === "read" ? 0.7 : 1,
                      padding: "0.5rem 0.75rem",
                      borderBottom: "1px solid #eee",
                    }}
                  >
                    <div className="d-flex justify-content-between">
                      {n.action_url ? (
                        <Link
                          to={n.action_url}
                          onClick={() => this.markOne(n.id)}
                        >
                          <strong>{n.title}</strong>
                        </Link>
                      ) : (
                        <strong onClick={() => this.markOne(n.id)}>{n.title}</strong>
                      )}
                      <button
                        type="button"
                        className="btn btn-link btn-sm"
                        aria-label="Dismiss"
                        onClick={(e) => this.dismissOne(e, n.id)}
                      >
                        ×
                      </button>
                    </div>
                    {n.body ? <p className="mb-0 small">{n.body}</p> : null}
                    {n.created_at ? (
                      <p className="mb-0 small text-muted">
                        {formatNotificationTime(n.created_at)}
                      </p>
                    ) : null}
                  </div>
                ))
              )}
            </div>
            <div className="notification-seeall">
              <Link to="/notification/view-all">See all</Link>
            </div>
          </div>
        ) : null}
      </li>
    );
  }
}

export default NotificationBell;
